import React from 'react';
import { P } from '@frontend/shadcn/components/typography/p';
import { H3 } from '@frontend/shadcn/components/typography/h3';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import xss from 'xss';
import { ViewMode } from '../constants';

interface ConfirmationProps {
  view: ViewMode;
  logo: string;
  programName: string;
  brandName: string;
  title: string;
  description: string;
  backgroundColor: string;
}

export const Confirmation = ({
  view,
  logo,
  programName,
  brandName,
  title,
  description,
  backgroundColor,
}: ConfirmationProps) => {
  const isDesktop = view === ViewMode.DESKTOP;
  if (isDesktop) {
    return (
      <div className="flex p-6 gap-4 flex-col h-full text-center" style={{ backgroundColor }}>
        <div className="p-4 rounded-4xl h-full flex flex-col gap-4 bg-white w-[60%] mx-auto">
          <div className="flex flex-row gap-2 items-center">
            <img src={logo} alt="form" className="w-8 h-8 rounded-lg object-cover" />
            <div className="flex flex-col">
              <P className="text-xs font-medium text-grey-6" fontWeight="font-medium">
                {programName}
              </P>
              <P className="text-xs font-normal text-grey-5">{brandName}</P>
            </div>
          </div>
          <div className="flex flex-col gap-2 items-center justify-center py-10 flex-1">
            <FontAwesomeIcon icon={faCheckCircle} className="text-green-4 h-10 w-10" />
            <H3 className="text-lg font-medium text-grey-6 mb-0">{title}</H3>
            <div className="text-sm font-normal text-grey-5 mb-0" dangerouslySetInnerHTML={{ __html: xss(description) }} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex p-6 gap-4 flex-col h-full text-center">
      <div className="flex flex-row gap-2 items-center">
        <img src={logo} alt="form" className="w-8 h-8 rounded-lg object-cover" />
        <div className="flex flex-col">
          <P className="text-xs font-medium text-grey-6" fontWeight="font-medium">
            {programName}
          </P>
          <P className="text-xs font-normal text-grey-5">{brandName}</P>
        </div>
      </div>
      <div className="flex flex-col gap-2 items-center justify-center mb-9 flex-1">
        <FontAwesomeIcon icon={faCheckCircle} className="text-green-4 h-10 w-10" />
        <H3 className="text-lg font-medium text-grey-6 mb-0">{title}</H3>
        <div className="text-sm font-normal text-grey-5 mb-0" dangerouslySetInnerHTML={{ __html: xss(description) }} />
      </div>
    </div>
  );
};
